import { apiClient } from './api';

export interface SalesGoal {
  id: number;
  sales_rep_id: number;
  sales_rep_name: string | null;
  period_start: string;
  period_end: string;
  target_revenue: number;
  target_orders: number;
  target_new_customers: number;
  target_visits: number;
  created_at: string;
  updated_at: string;
}

export interface WeekProgress {
  week_index: number;
  label: string;
  start: string;
  end: string;
  orders_count: number;
  revenue: number;
}

export interface TopProduct {
  rank: number;
  sku_id: number;
  product_name: string;
  orders_count: number;
  revenue: number;
}

export interface GoalProgress {
  goal: SalesGoal;
  achieved_revenue: number;
  achieved_orders: number;
  achieved_new_customers: number;
  achieved_visits: number;
  achieved_revenue_pct: number;
  achieved_orders_pct: number;
  achieved_visits_pct: number;
  weeks: WeekProgress[];
  top_products: TopProduct[];
}

export interface UpsertGoalInput {
  sales_rep_id: number;
  period_start: string;
  period_end: string;
  target_revenue?: number;
  target_orders?: number;
  target_new_customers?: number;
  target_visits?: number;
}

export async function listGoals(filters: { sales_rep_id?: number; active_for?: string } = {}): Promise<SalesGoal[]> {
  const raw = await apiClient.get<any>('/sales-goals', filters as Record<string, any>);
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
}

export async function getGoal(id: number): Promise<SalesGoal> {
  return apiClient.get<SalesGoal>(`/sales-goals/${id}`);
}

export async function getProgress(asOf?: string): Promise<GoalProgress> {
  return apiClient.get<GoalProgress>('/sales-goals/progress', asOf ? { as_of: asOf } : undefined);
}

export async function upsertGoal(input: UpsertGoalInput): Promise<SalesGoal> {
  return apiClient.post<SalesGoal>('/sales-goals', input);
}

export async function deleteGoal(id: number): Promise<void> {
  await apiClient.delete<void>(`/sales-goals/${id}`);
}
